import { createStore } from 'vuex';
import SignIn from '../SignIn/store';

export default createStore({
  state: {
    authenticated: false,
    pendingRequests: 0
  },
  mutations: {
    beginRequest(state) {
      state.pendingRequests++;
    },
    endRequest(state) {
      if (state.pendingRequests > 0) {
        state.pendingRequests--;
      }
    }
  },
  modules: {
    SignIn
  }
});
